module.exports = __webpack_public_path__ + "static/media/door00.aa7c0e87.jpg";